import React from 'react';
import { cn } from '../lib/utils';

export default function PageHeader({ title, subtitle, actions, className }) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between mb-8',
        className
      )}
      data-testid="page-header"
    >
      <div className="min-w-0">
        <h1
          className="text-[28px] font-extrabold text-foreground leading-none"
          style={{ letterSpacing: '-0.03em' }}
          data-testid="page-title"
        >
          {title}
        </h1>
        {subtitle && (
          <p className="text-[13px] text-muted-foreground mt-1.5" data-testid="page-subtitle">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
